import { PropsWithChildren, Suspense } from 'react';
import { Redirect, Route } from 'react-router-dom';
import Loading from './Loading';
import { useAuthState } from 'shared/stores';

type PrivateLazyRouteProps = { path: string; unauthorizedRoute: string; isAllowed: boolean };

export function PrivateLazyRoute({
    children,
    path,
    unauthorizedRoute,
    isAllowed,
}: PropsWithChildren<PrivateLazyRouteProps>) {
    const authState = useAuthState();
    const user = authState.user.get();

    if (!user) {
        return <Loading />;
    }

    return (
        <Route path={path}>
            {isAllowed ? <Suspense fallback={<Loading />}>{children}</Suspense> : <Redirect to={unauthorizedRoute} />}
        </Route>
    );
}
